/**
 * File Storage Store Module
 *
 * Manages file upload and storage backend configuration.
 * Provides functionality to:
 * - Upload images and documents to Ceph storage
 * - Retrieve storage backend type (Azure or Ceph)
 * - Fetch all images from the configured storage
 * - Check storage backend type with helper getters
 *
 * @module store/modules/filestorage
 */

import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";
import { Module } from "vuex/types";
import { FileUploadState } from "./types";
import { RootState } from "@/store/types";

const FileUpload: Module<FileUploadState, RootState> = {
  // namespaced: true,
  actions,
  getters,
  mutations,
  state,
};

export default FileUpload;
